<div class="report-container">
  <hyperkit-typography variant="h5">Conclusion</hyperkit-typography>

  <hyperkit-select
  label="Outcome"
  [options]="outcomeValues"
  [(ngModel)]="outcome"
  (selectionChange)="onSelectionChange($event)"
  ></hyperkit-select>

  <hunt-details-editor 
  title="{{huntContext.editor.outcomeDependentField()}}" 
  [value]="huntContext.editor.outcomeDependent()"
  (valueChange)="huntContext.editor.updateOutcomeDependent($event)"
  >
  </hunt-details-editor>  

  <hunt-details-editor 
  title="Conclusion" 
  [value]="huntContext.editor.hypothesis()"
  (valueChange)="huntContext.editor.updateHypothesis($event)"
  >
  </hunt-details-editor>
</div>       